import base from './base.js'

// 分享mixin
/*  1. 引入该mixin    
    mixins: [app.mixin.shareMixin]
    2. 在合适的时机调用this.v_shareResolve方法, 传入分享参数;如:
    created() {
        this.v_shareResolve({
            title: '我是标题',
            desc: '我是要分享的描述信息、内容。。。',
            link: location.href,
            imgUrl: 'http://static.dingtalk.com/media/lADPBbCc1YOadDfNAoDNAoA_640_640.jpg'
        })
    }*/
export const shareMixin = {
    created: function () {
        let sharePromise = new Promise(resolve => (this.v_shareResolve = resolve))

        if (window.__wxjs_environment === 'miniprogram') {
            this.v_updateShareMessage()
        }

        this.$on('pageshow', () => {
            sharePromise.then(params => {
                this.v_shareParams = params
                this.v_updateShareMessage()
            })
        })
    },
    methods: {
        v_updateShareMessage() {
            if (this.v_shareParams) {
                let options = typeof this.v_shareParams === 'function' ? this.v_shareParams() : this.v_shareParams

                if (window.__wxjs_environment === 'miniprogram') {
                    wx.miniProgram.postMessage({
                        data: {
                            options: options,
                            fullPath: options ? this.$route.fullPath : '/'
                        }
                    })
                } else {
                    options && app.sdk.share(options)
                }
            }
        }
    }
}
